import React from 'react'

import Hero from '../hero/hero'
import SlicesWrapper from '../slices/slicesWrapper'
import PushContent from '../pushContent'

const PageLayout = ({data, currentUrl, furtherContent, blogHubTitle}) => {
  const isBlog = data.customType === 'Blog'

  return (
    <>
      <Hero 
        currentUrl={currentUrl}
        data={data} 
        type="page"
        customType={isBlog ? 'Blog' : null}
        blogHubTitle={blogHubTitle} />

      <div>
        <SlicesWrapper slices={data.slices} />
      </div>

      { ((furtherContent.nodes !== undefined && furtherContent.nodes.length > 0) || data.pushPages !== null) &&
        <PushContent data={data.pushPages} autoItems={furtherContent} />
      }
    </>
  )
}

export default PageLayout;